<div class="main">
    <div class="section">
        <div class="container">
            <div class="row">
                <div class="col-md-8 ml-auto mr-auto text-center">
                    <h4 class="title">eMD Technologies Referral Submission</h4>
                </div>
            </div>
            

            
            <div class="row">
                <div class="col-md-6 ml-auto mr-auto text-center">
                   
                    <form [formGroup]="contactUsForm" class="contact">

                        <input formControlName="website" type="text" autocomplete="off" tabindex="-1"
                            aria-hidden="true"
                            style="position:absolute;left:-9999px;width:1px;height:1px;opacity:0;">

                        <h4 class="title">Dear eMD Technologies, </h4>
                        <h4 class="title "> I would like to refer the following healthcare provider.</h4>
                        <div class="row ms-auto me-auto">
                           
                            <div class="col-12 col-md-7 ms-auto me-auto">
                             
                                <input formControlName="referral_identifier" type="text" class="form-control"
                                    placeholder="My Email">

                            </div>
                            <div class="cl-12 col-md-5 ms-auto me-auto">
                               
                                <input formControlName="practice_number" type="text" class="form-control"
                                    placeholder="My Practice Number">

                            </div>
                            <!-- <div class="col-md-6">
                                <input type="text" class="form-control" placeholder="Last Name">
                            </div> -->
                        </div>
                        <h4 class="title">Referred Healthcare Provider Details:</h4>
                        <div class="row">
                            <div class="col-md-6">
                             
                                <input formControlName="first_name" type="text" class="form-control"
                                    placeholder="First Name">
                            </div>
                            <div class="col-md-6">
                               
                                <input formControlName="last_name" type="text" class="form-control"
                                    placeholder="Last Name">
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                               
                                <input formControlName="email" type="text" class="form-control" placeholder="Email">
                            </div>
                            <div class="col-md-6">
                                
                                <input formControlName="mobile" type="text" class="form-control" placeholder="Mobile">
                            </div>
                        </div>



                        


        

                        <div class="row">
                            <div class="col-md-6 ml-auto mr-auto">

                                <div *ngIf="contactUsForm.valid == true">

                                    <button (click)="open(classic, '')" class="btn btn-primary btn-block btn-round">Send
                                    </button>

                                </div>

                                <div *ngIf="contactUsForm.valid == false">
                                    <small class="text-danger form-text text-muted">All fields are required!</small>
                                    <small *ngIf="f['referral_identifier'].errors && f['referral_identifier'].errors.required"
                                    class="text-danger form-text text-muted">*Your email is missing!</small>
                                    <small *ngIf="f['practice_number'].errors && f['practice_number'].errors.required"
                                    class="text-danger form-text text-muted">*Your practice is missing!</small>

                                    <!-- <small *ngIf="f['first_name'].errors && f['first_name'].errors.required"
                                    class="text-danger form-text text-muted">*First Name is missing!</small> -->

                                    <!-- <small *ngIf="f['last_name'].errors && f['last_name'].errors.required"
                                    class="text-danger form-text text-muted mr-auto">*Last Name is missing!</small>


                                    <small *ngIf="f['email'].errors && f['email'].errors.required"
                                    class="text-danger form-text text-muted">*Email is missing!</small>

                                    <small *ngIf="f['mobile'].errors && f['mobile'].errors.required"
                                    class="text-danger form-text text-muted">*Mobile is missing!</small> -->

                                    <button disabled class="btn btn-primary btn-block btn-round">Send </button>

                                </div>


                            </div>
                        </div>
                    </form>
                  
                </div>
            </div>







            <ng-template #classic let-c="close" let-d="dismiss">
                <ng-container *ngIf="submitState === 'pending'">
                    <div class="modal-body text-center py-4">
                        <div class="spinner-border text-primary mb-3" role="status">
                            <span class="sr-only">Loading...</span>
                        </div>
                        <p class="mb-0">Submitting your request&hellip;</p>
                    </div>
                </ng-container>

                <ng-container *ngIf="submitState === 'success'">
                    <div class="modal-header">
                        <h5 class="modal-title text-center">Referral Submitted</h5>
                        <button type="button" class="close" (click)="d('Cross click')">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        Thank you, a email have been sent to relevant parties and we will contact you shortly.
                    </div>
                    <div class="modal-footer">
                        <div class="divider"></div>
                        <div class="right-side">
                            <button type="button" class="btn btn-success btn-link" (click)="c('Close click')">Ok</button>
                        </div>
                    </div>
                </ng-container>

                <ng-container *ngIf="submitState === 'error'">
                    <div class="modal-header">
                        <h5 class="modal-title text-center text-danger">Submission failed</h5>
                        <button type="button" class="close" (click)="d('Cross click')">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        We couldn't submit your request. Please check your connection and try again, or contact us directly.
                    </div>
                    <div class="modal-footer">
                        <div class="divider"></div>
                        <div class="right-side">
                            <button type="button" class="btn btn-danger btn-link" (click)="c('Close click')">Close</button>
                        </div>
                    </div>
                </ng-container>
            </ng-template>

        </div>
    </div>
</div>